import type { ReactElement } from "react";
import { CmtsRolesPage } from "../../pages/cmtsRolesPage.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(_props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsRolesPage />;
}

export default Component;
